















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AgentNode from "./AgentNode.vue";
import ConnectionArrow from "./ConnectionArrow.vue";
import { nodeData } from "./nodeData";
import { connection } from "./connection";
import { point } from "./point";

@Component({
  components: { agent_node: AgentNode, connection_arrow: ConnectionArrow },
})
export default class workflow_builder extends Vue {
  @Prop({
    type: Object,
    required: false,
    default: () => ({
      nodes: [],
      connections: [],
      id: "",
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      name: "",
    }),
  })
  readonly value!: {
    nodes: nodeData[];
    connections: connection[];
    name: string;
    id: string;
    createdAt: string;
    updatedAt: string;
  };
  public nodes: nodeData[] = [];
  public connections: connection[] = [];
  public id: string = "";
  public createdAt: string = new Date().toISOString();
  public updatedAt: string = new Date().toISOString();
  public name: string = "";

  public selectedNodeId: string | null = null;
  public selectedConnId: string | null = null;

  public isLinking: boolean = false;
  public linkSource: nodeData | null = null;
  public tempEnd: point = { x: 0, y: 0 };
  public hoveredNodeId: string | null = null; // <-- NUEVO

  public mounted() {
    if (this.value && this.value.nodes && this.value.connections) {
      this.nodes = JSON.parse(JSON.stringify(this.value.nodes));
      this.connections = JSON.parse(JSON.stringify(this.value.connections));
      this.id = this.value.id;
      this.name = this.value.name;
      this.createdAt = this.value.createdAt;
      this.updatedAt = this.value.updatedAt;
    } else {
      // DEMO: sustituye por tus datos
      this.nodes = [
        { id: "A", x: 120, y: 120, w: 220, h: 80, title: "Agente A" },
        { id: "B", x: 520, y: 260, w: 220, h: 80, title: "Agente B" },
        { id: "C", x: 520, y: 60, w: 220, h: 80, title: "Agente C" },
      ];
    }

    // Captura Delete/Backspace
    const el = this.$refs.canvas as HTMLElement;
    if (el) {
      el.focus();
    }

    // Cancela linking si sueltas fuera de un puerto IN
    window.addEventListener("pointerup", this.onWindowPointerUp, true);
  }

  public beforeDestroy() {
    window.removeEventListener("pointerup", this.onWindowPointerUp, true);
  }

  // === Selección ===
  public selectNode(id: string) {
    this.selectedNodeId = id;
    this.selectedConnId = null;
  }
  public onSelectConnection(id: string) {
    this.selectedConnId = id;
    this.selectedNodeId = null;
  }

  // === Drag de nodos ===
  public onNodeDrag(payload: { id: string; x: number; y: number }) {
    const i = this.findNodeIndex(payload.id);
    if (i !== -1) {
      this.nodes[i].x = payload.x;
      this.nodes[i].y = payload.y;
      this.emitWorkflowUpdate();
    }
  }

  get workflow() {
    return {
      nodes: this.nodes,
      connections: this.connections,
      id: this.id,
      name: this.name,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      // Puedes agregar más propiedades si lo necesitas
    };
  }

  public loadWorkflow(data: { nodes: nodeData[]; connections: connection[] }) {
    this.nodes = data.nodes;
    this.connections = data.connections;
  }

  // === Linking ===
  public onStartLink(nodeId: string, anchor: point) {
    console.log("StartLink to node:", { nodeId, anchor });
    const n = this.findNode(nodeId);
    if (!n) {
      return;
    }
    this.isLinking = true;
    this.linkSource = n;
    this.tempEnd = { x: anchor.x, y: anchor.y };

    console.log("Found nodew:", this.linkSource);
  }

  public onFinishLink(targetNodeId: string) {
    console.log("Finish link to node:", {
      targetNodeId,
      linkSource: this.linkSource,
    });
    if (!this.isLinking || this.linkSource === null) {
      return;
    }
    console.log("Link source node:", this.linkSource.id);
    // Permite enganchar si no es el mismo nodo y no existe la conexión
    if (
      targetNodeId !== this.linkSource.id &&
      !this.hasConnection(this.linkSource.id, targetNodeId)
    ) {
      this.connections.push({
        id: this.uid(),
        from: this.linkSource.id,
        to: targetNodeId,
      });
      this.emitWorkflowUpdate();
    }
    this.cancelLinking("onFinishLink");
  }

  public onWindowPointerUp(e: PointerEvent) {
    console.log("Window pointer up", {
      linking: this.isLinking,
      source: this.linkSource,
    });
    // Si estabas enlazando pero no has soltado sobre un puerto IN, cancela
    // (el puerto IN dispara finishLink y llega antes que este handler en capture=true)
    setTimeout(() => {
      if (this.isLinking && this.linkSource !== null) {
        this.cancelLinking("onWindowPointerUp");
      }
    }, 0);
  }

  public onPointerMove(e: PointerEvent) {
    if (!this.isLinking) {
      return;
    }
    const canvas = this.$refs.canvas as HTMLElement;
    if (!canvas) {
      return;
    }
    const rect = canvas.getBoundingClientRect();
    this.tempEnd = { x: e.clientX - rect.left, y: e.clientY - rect.top };
  }

  public onDeleteNode(nodeId: string) {
    console.log("Delete node:", nodeId);
    // Elimina el nodo
    const idx = this.findNodeIndex(nodeId);
    if (idx !== -1) {
      this.nodes.splice(idx, 1);
    }
    // Elimina todas las conexiones asociadas
    this.connections = this.connections.filter(
      (c) => c.from !== nodeId && c.to !== nodeId
    );
    // Limpia selección si era el nodo eliminado
    if (this.selectedNodeId === nodeId) {
      this.selectedNodeId = null;
    }
    this.emitWorkflowUpdate();
  }

  public cancelLinking(chivato: string) {
    console.log("Cancel linking:", chivato);
    this.isLinking = false;
    this.linkSource = null;
  }

  // === Eliminar conexiones ===
  public onKeyDown(e: KeyboardEvent) {
    const code = e.keyCode;
    if (this.selectedConnId && (code === 46 || code === 8)) {
      this.deleteConnection(this.selectedConnId);
      e.preventDefault();
    }
  }

  public deleteConnection(id: string) {
    const idx = this.findConnIndex(id);
    if (idx !== -1) {
      this.connections.splice(idx, 1);
      if (this.selectedConnId === id) {
        this.selectedConnId = null;
      }
      this.emitWorkflowUpdate();
    }
  }

  // === Utilidades ===
  private getAnchor(nodeId: string | point, side: "in" | "out"): point {
    // Permitir punto libre (flecha temporal)
    if ((nodeId as any).x !== undefined && (nodeId as any).y !== undefined) {
      return nodeId as point;
    }
    const n = this.findNode(nodeId as string);
    if (!n) {
      return { x: 0, y: 0 };
    }

    if (side === "out") {
      // Derecha-centro (salida)
      return { x: n.x + n.w, y: n.y + n.h / 2 };
    } else {
      // Izquierda-centro (entrada)
      return { x: n.x, y: n.y + n.h / 2 };
    }
  }

  private hasConnection(from: string, to: string): boolean {
    for (let i = 0; i < this.connections.length; i++) {
      const c = this.connections[i];
      if (c.from === from && c.to === to) {
        return true;
      }
    }
    return false;
  }

  private findNode(id: string): nodeData | null {
    const i = this.findNodeIndex(id);
    return i !== -1 ? this.nodes[i] : null;
  }
  private findNodeIndex(id: string): number {
    for (let i = 0; i < this.nodes.length; i++) {
      if (this.nodes[i].id === id) {
        return i;
      }
    }
    return -1;
  }
  private findConnIndex(id: string): number {
    for (let i = 0; i < this.connections.length; i++) {
      if (this.connections[i].id === id) {
        return i;
      }
    }
    return -1;
  }

  public onHoverIn(nodeId: string) {
    this.hoveredNodeId = nodeId;
  }
  public onHoverOut(nodeId: string) {
    if (this.hoveredNodeId === nodeId) {
      this.hoveredNodeId = null;
    }
  }
  private uid(): string {
    return (
      "c_" +
      Math.random()
        .toString(36)
        .substr(2, 9)
    );
  }
  @Watch("linkSource")
  onLinkedNodesChanged() {
    // Aquí puedes manejar los cambios en LinkedNodes si es necesario
    console.log("linkSource changed:", this.linkSource);
  }

  @Watch("value", { deep: true })
  onValueChanged(newVal: any) {
    if (newVal && newVal.nodes && newVal.connections) {
      this.nodes = JSON.parse(JSON.stringify(newVal.nodes));
      this.connections = JSON.parse(JSON.stringify(newVal.connections));
      this.id=this.value.id;
      this.name=this.value.name;
      this.createdAt=this.value.createdAt;
      this.updatedAt=this.value.updatedAt;
    }
  }

  private emitWorkflowUpdate() {
    this.$emit("input", this.workflow);
  }
}
